/**
 * MockSessionsStore — web mirror of `Sources/Store/MockSessionsStore.swift`.
 *
 * In-memory tmux store with sample sessions so Brain ▸ Sessions renders
 * standalone in MOCK mode. Returns instantly (small delay).
 */

import type { TmuxListResponse, TmuxSession } from '../models/brainFs';
import type { SessionsStore } from './SessionsStore';

const MOCK_LATENCY_MS = 250;

export class MockSessionsStore implements SessionsStore {
  private readonly sessions: TmuxSession[] = seed();

  private async delay(): Promise<void> {
    await new Promise((r) => setTimeout(r, MOCK_LATENCY_MS));
  }

  async list(): Promise<TmuxListResponse> {
    await this.delay();
    return { count: this.sessions.length, sessions: this.sessions };
  }
}

function seed(): TmuxSession[] {
  return [
    {
      name: 'claude-factory-app',
      createdAt: '2026-07-20T00:06:00Z',
      windows: 3,
      attached: true,
      paneCurrentCommand: 'node',
      paneCurrentPath: '/Users/owner/Code/factory-app-filestmux/web',
      panePid: 48213,
    },
    {
      name: 'claude-brain-mcp',
      createdAt: '2026-07-19T23:10:00Z',
      windows: 2,
      attached: false,
      paneCurrentCommand: 'wrangler',
      paneCurrentPath: '/Users/owner/Code/claude-brain-mcp',
      panePid: 44120,
    },
    {
      name: 'gtm-loop',
      createdAt: '2026-07-19T14:30:00Z',
      windows: 1,
      attached: false,
      paneCurrentCommand: 'python',
      paneCurrentPath: '/Users/owner/Code/trendy-stream',
      panePid: 39880,
    },
    {
      name: 'nouri-testflight',
      createdAt: '2026-07-18T22:12:00Z',
      windows: 4,
      attached: false,
      paneCurrentCommand: 'xcodebuild',
      paneCurrentPath: '/Users/owner/Code/nouri-ios-app',
      panePid: 30122,
    },
  ];
}
